interface WaitingListNotificationDetails {
  id: string;
  title: string;
  start_date: string;
  start_time: string;
  location?: string;
  base_url: string;
}

export function getWaitingListNotificationTemplate(event: WaitingListNotificationDetails) {
  const eventUrl = `${event.base_url}/events/${event.id}`;
  
  const subject = `🎉 ¡Buenas noticias! Estás confirmado para ${event.title}`;
  
  const formattedDate = new Date(event.start_date).toLocaleDateString('es-AR', {
    weekday: 'long', 
    month: 'long', 
    day: 'numeric',
    year: 'numeric'
  });
  
  const body = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>${subject}</title>
      <style>
        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
          line-height: 1.6;
          color: #1f2937;
          margin: 0;
          padding: 0;
          background: linear-gradient(135deg, #e0f2fe 0%, #fff9c4 35%, #dcfce7 100%);
          min-height: 100vh;
        }
        .email-container {
          max-width: 600px;
          margin: 40px auto;
          background-color: #ffffff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        }
        .header {
          background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
          padding: 40px 30px;
          text-align: center;
        }
        .header h1 {
          margin: 0;
          color: #1f2937;
          font-size: 28px;
          font-weight: 700;
        }
        .success-badge {
          background: #10b981;
          color: white;
          padding: 8px 16px;
          border-radius: 20px;
          font-weight: 600;
          font-size: 14px;
          margin-bottom: 16px;
          display: inline-block;
        }
        .content {
          padding: 40px 30px;
        }
        .good-news {
          background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
          border: 1px solid #10b981;
          border-radius: 8px;
          padding: 24px;
          margin: 24px 0;
          text-align: center;
        }
        .good-news h3 {
          margin: 0 0 8px 0;
          color: #065f46;
          font-size: 20px;
          font-weight: 600;
        }
        .good-news p {
          margin: 0;
          color: #047857;
          font-size: 16px;
        }
        .event-details {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          padding: 24px;
          border-radius: 8px;
          margin: 24px 0;
          border: 1px solid #e5e7eb;
        }
        .detail-row {
          display: flex;
          margin-bottom: 12px;
          align-items: center;
        }
        .detail-row:last-child {
          margin-bottom: 0;
        }
        .detail-label {
          width: 80px;
          font-weight: 600;
          color: #374151;
          font-size: 14px;
        }
        .detail-value {
          flex: 1;
          color: #1f2937;
          font-size: 14px;
        }
        .cta-button {
          display: inline-block;
          background: linear-gradient(135deg, #10b981 0%, #059669 100%);
          color: white !important;
          text-decoration: none;
          padding: 16px 32px;
          border-radius: 8px;
          font-weight: 600;
          font-size: 16px;
          margin-top: 24px;
          text-align: center;
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
        }
        .footer {
          padding: 24px 30px;
          text-align: center;
          font-size: 12px;
          color: #9ca3af;
          border-top: 1px solid #e5e7eb;
          background: #f9fafb;
        }
        .logo {
          font-size: 24px;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 8px;
        }
        @media only screen and (max-width: 600px) {
          .email-container {
            margin: 20px;
          }
          .header, .content {
            padding: 24px 20px;
          }
          .cta-button {
            width: 100%;
            box-sizing: border-box;
          }
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="header">
          <div class="logo">Punta Tech Meetup</div>
          <div class="success-badge">✨ CONFIRMADO</div>
          <h1>¡Saliste de la lista de espera!</h1>
        </div>
        
        <div class="content">
          <div class="good-news">
            <h3>🎉 ¡Excelente noticia!</h3>
            <p>Se liberó un lugar y ahora estás confirmado para este evento.</p>
          </div>
          
          <h2>${event.title}</h2>
          
          <div class="event-details">
            <div class="detail-row">
              <div class="detail-label">📅 Fecha:</div>
              <div class="detail-value">${formattedDate}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">🕐 Hora:</div>
              <div class="detail-value">${event.start_time}</div>
            </div>
            <div class="detail-row">
              <div class="detail-label">📍 Lugar:</div>
              <div class="detail-value">${event.location || 'Online'}</div>
            </div>
          </div>
          
          <p>Agendalo y preparate para un gran evento.</p>
          
          <center>
            <a href="${eventUrl}" class="cta-button">Ver detalles del evento</a>
          </center>
        </div>
        
        <div class="footer">
          <p>Este aviso fue enviado por <strong>Punta Tech Meetup</strong>.</p>
        </div>
      </div>
    </body>
    </html>
  `;

  return { subject, body };
}